import React from 'react';
import './App.css';
import { Outlet } from "react-router-dom";

function App() {
    return (
        <>
            <div
                className="pointer-events-none absolute inset-x-0 top-0 left-1/2 h-32 sm:h-48 md:h-64 w-full -translate-x-1/2 overflow-hidden opacity-60"
            >
                <div className="absolute inset-0 flex">
                    <div className="h-full w-1/2" style={{ backgroundColor: "#c3e5dc" }} />
                    <div className="h-full w-1/2" style={{ backgroundColor: "#347564" }} />
                </div>
                <div className="relative flex justify-center">
                    <svg
                        className="h-full w-auto min-w-full"
                        viewBox="0 0 1750 308"
                        preserveAspectRatio="xMidYMid slice"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M284.161 308H1465.84L875.001 182.413 284.161 308z" fill="#245246" />
                        <path d="M1465.84 308L16.816 0H1750v308h-284.16z" fill="#347564" />
                        <path d="M1733.19 0L284.161 308H0V0h1733.19z" fill="#c3e5dc" />
                        <path d="M875.001 182.413L1733.19 0H16.816l858.185 182.413z" fill="#5ab59d" />
                    </svg>
                </div>
            </div>
            <main className="relative z-10 min-h-screen">
                <Outlet />
            </main>
        </>
    );
}

export default App;
